'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _LeftOutlined = _interopRequireDefault(require('./lib/icons/LeftOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _LeftOutlined;
exports.default = _default;
module.exports = _default;